import {nextActionCache, tokenCache} from "./cache"
import {getENV, hashHasChannel, hashHasAppid, isWeixin, isAlipay, isDev, isDevelopment} from "./util"
import {systemService} from "@/services/system";
import {VERSION5_2_4, VERSION5_3_0} from "@/lib/version";
import {devGetTempToken} from "@/utils/devGetTempToken";

// const APPID = "wxa49f90b4ff678ef2";
let query = url("?") || {}, hash = url("#") || {};
export default (cb) => {
  // .replace()
  let href = location.href;
  let redirect_uri = encodeURIComponent(href);
  // let jumpTo = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATE&component_appid=${COMPONENT_APPID}#wechat_redirect`;
  let UA = window.navigator.userAgent.toLocaleLowerCase();


  if (VERSION5_2_4) {
    cb();
  } else {
    auto(cb);
  }
}

function auto(cb) {
  /*微信打开*/
  if (isWeixin()) {
    /*本地有openid*/
    let openidFromCache = tokenCache.get();
    if (openidFromCache) {
      cb();
    } else if (hash.openid) {
      tokenCache.set(hash.openid);
      cb()
    } else if (query.openid) {
      tokenCache.set(query.openid);
      cb()
    }
    /*本地无openid*/
    else {
      toOauth2Page();
    }
    /*支付宝打开*/
  } else if (isAlipay()) {
    /*本地有openid*/
    let openidFromCache = tokenCache.get();
    if (openidFromCache) {
      cb();
    } else {
      let callback = location.href;
      callback = encodeURIComponent(callback);
      let url = 'login.html?callback=' + callback + '&channel=' + query.channel;
      location.replace(url);
    }
  }
  /*非微信支付宝打开*/
  else {
    let env = getENV();
    process.env.NODE_ENV === "development" ? tokenCache.set('omrmBv30ZgdVZ-EbIy8DSrHeKam4') : '';
    // omrmBv1p9porIc2z0IZkPm4q7dS4 李明卫-开发
    // omrmBv7QJCKfA86q1WZ8QYXPLgcs 蒋杭锦-开发
    // o4-pXuIKtl-skMMDVoFU5Xf7nez0 杨海彬-测试
    // omrmBvz3LicTA3rGdfITb_AyZ2lw 杨海彬-开发
    // omrmBv30ZgdVZ-EbIy8DSrHeKam4 车欢欢-开发
    // o4-pXuJQzmEzv9lPvb_FjBgx_lsk 车欢欢-测试
    cb();
  }
}

export const tempOpenidArray = [
  'odQo50Ui8Pek0RRxHjfCDxpQdIr4',// 0李明卫-开发
]

export function toOauth2Page() {
  if (isDevelopment()) {
    devGetTempToken(tempOpenidArray[0]).then(token => {
      location.replace(location.href + '&openid=' + token);
      location.reload();
      //Log('url', url);
    });
  } else if (isWeixin()) {
    let channel = query.channel || hashHasChannel(hash) || '';
    if (channel) {
      systemService.channelDetails(channel).then(({appid}) => {
        if (appid) go(appid); else go(getENV().appid);
      })
    } else {
      go(getENV().appid);
    }
  } else if (isAlipay()) {
    // https://www.gjwlyy.com/oauth2/?appid=wx3d274480f31f6de2&callback=https%3A%2F%2Fwww.baidu.com&plat=pro
    location.replace(`${getENV().alipay_oauth2}/oauth2/?appid=wx3d274480f31f6de2&callback=${encodeURIComponent(location.href)}&plat=pro`)
  }
}

export function directGetOpenId() {
  if (isDevelopment()) {
    location.replace(location.href + '&openid=' + tempOpenidArray[6]);
    location.reload();
  } else {
    let channel = query.channel || hashHasChannel(hash) || '';
    if (channel) {
      systemService.channelDetails(channel).then(({appid}) => {
        if (appid) goWithoutOauthurl(appid); else goWithoutOauthurl(getENV().appid);
      })
    } else {
      goWithoutOauthurl(getENV().appid);
    }
  }
}

function go(appId) {
  location.replace(makeRedirectUrl(appId));
}

function goWithoutOauthurl(appId) {
  location.replace(makeRedirectWithoutOauthurl(appId));
}

function makeRedirectUrl(appId) {
  const redirect = getENV().wx_oauth2 + `/wechat/plat/oauth/${appId}?url=${encodeURIComponent(location.href)}&oauthurl=` + makeOauthUrl()
  Log('redirect授权地址', redirect);
  return redirect;
}

function makeRedirectWithoutOauthurl(appId) {
  const redirect = getENV().wx_oauth2 + `/wechat/plat/oauth/${appId}?url=${encodeURIComponent(location.href)}`
  Log('redirect授权地址', redirect);
  return redirect;
}

function makeOauthUrl() {
  const oauthurl = getENV().oauthurl + `/api/wechat/oauth/callback`
  Log('oauthurl授权地址', oauthurl);
  return encodeURIComponent(oauthurl);
}


// http://wechat-repeater.hztywl.cn/wechat/plat/oauth/wxa49f90b4ff678ef2?url=http%3A%2F%2Flocalhost%3A8080%2F%3Fv%3D5.3.0-5%26channel%3D3%23%2Faccount%2Fprelogin%3Fcallback%3D%252Fdaysurgery&oauthurl=https%3A%2F%2Fnethos.diandianys.com%2Fapi%2Fwechat%2Foauth%2Fcallback





// WEBPACK FOOTER //
// ./src/lib/auth2.js